<template>
  <div class="tb_wrap" id="printDiv" ref="pdfArea" :key="pdfKey" style="page-break-inside:avoid;">
    <table ref="printArea" style="width:980px;height:640px;" class="border-collapse">
      <colgroup>
        <col width="202px" />
        <col width="180px" />
        <col width="130px" />
        <col width="160px" />
        <col width="150px" />
      </colgroup>
      <thead>
        <tr class="fixed_top">
          <th class="p-2 border border-solid text-center table_header" style="font-size: 30px;">
            등록번호
          </th>
          <th class="p-2 border border-solid text-center table_header" style="font-size: 30px;" colspan="2">
            병실
          </th>
          <th class="p-2 border border-solid text-center table_header" style="font-size: 30px;">
            성별
          </th>
          <th class="p-2 border border-solid text-center table_header" style="font-size: 30px;">
            나이
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="colored">
          <td class="p-2 border border-solid text-center" id="chartNo2" style="font-size: 50px; line-height: 0.5;">
            3201
          </td>
          <td class="p-2 border border-solid text-center" id="roomNm" style="font-size: 50px; line-height: 0.5;"
            colspan="2"></td>
          <td class="p-2 border border-solid text-center" id="sex" style="font-size: 50px; line-height: 0.5;">
            F
          </td>
          <td class="p-2 border border-solid text-center" id="age" style="font-size: 50px; line-height: 0.5;">
            40
          </td>
        </tr>
      </tbody>
      <tr class="fixed_top">
        <th class="p-2 border border-solid text-center table_header" rowspan="2" style="font-size: 30px;">
          환자명
        </th>
        <td class="p-2 border border-solid text-center" rowspan="2" id="pname2" colspan="2"
          style="font-size: 70px;line-height: 0.5;">
          이지유
        </td>
        <th class="p-2 border border-solid text-center table_header" style="font-size: 30px;" colspan="2">
          생년월일
        </th>
      </tr>
      <tr class="colored">
        <td class="p-2 border border-solid text-center" id="birthdate" colspan="2" style="font-size: 30px;height:50px;">
          83-11-28
        </td>
      </tr>

      <tr class="fixed_top">
        <th class="p-2 border border-solid text-center table_header" rowspan="2" style="font-size: 30px;">
          공유내용
        </th>
        <th class="p-2 border border-solid text-center table_header" style="height:5px;font-size: 30px;" colspan="2">
          대피등급
        </th>
        <th class="p-2 border border-solid text-center table_header" style="height:5px;font-size: 30px;" colspan="2">
          낙상고
        </th>
      </tr>
      <tr class="colored">
        <td class="p-2 border border-solid text-center" style="height:50px;font-size: 40px; line-height: 0.5;" id="grade"
          colspan="2">
          <span style="height:50px;font-size: 40px; line-height: 0.5; color:blue;">C</span>
        </td>
        <td class="p-2 border border-solid text-center" id="dnr" colspan="2" style="font-size: 30px;"></td>
      </tr>

      <tr class="fixed_top">
        <th class="p-2 border border-solid text-center table_header" rowspan="2"
          style="font-size: 30px; line-height: 0.5;">
          입원일
        </th>
        <th class="p-2 border border-solid text-center" id="inDate" style="font-size: 30px; line-height: 0.5;" rowspan="2"></th>
        <th class="p-2 border border-solid text-center table_header" style="font-size: 30px;">
          병동주치의
        </th>
        <th class="p-2 border border-solid text-center" id="doctorWard" style="font-size: 45px; line-height: 0.5;"
          colspan="2">
        </th>
      </tr>
      <tr class="fixed_top">
        <th class="p-2 border border-solid text-center table_header" style="font-size: 30px;">
          양방주치의
        </th>
        <th class="p-2 border border-solid text-center" id="doctorWest" style="font-size: 45px; line-height: 0.5;"
          colspan="2">
        </th>
      </tr>
    </table>

    <table style="width:940px;margin-top: 10px;" class="border-collapse">
      <colgroup>
        <col width="210" />
        <col width="226.92913385827" />
        <col width="200" />
        <col width="200" />
      </colgroup>
      <thead>
        <tr class="colored">
          <td class="p-2 border border-solid text-center" id="pname" colspan="2"
            style="height:200px; line-height: 0.5; font-size: 100px;">
            이지유
          </td>
          <td class="p-2 border border-solid text-center" id="doctor2" style="height:200px; font-size: 40px;"></td>
          <td class="p-2 border border-solid text-center" id="" style="height:200px;font-size: 100px;">
            <span style="height:200px;font-size: 100px; color:blue;">C</span>
          </td>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>
import axiosClass from "@/../util/axiosClass";
import html2canvas from "html2canvas";
import Vue from "vue";
import $ from "jquery";
import VueHtml2Canvas from "vue-html2canvas";
Vue.use(VueHtml2Canvas);
export default {
  data() {
    return {
      pdfKey: 0,
      userUid: '',
      lists: [],
      chartNo: '',
      patientUsername: '',
      patientBirthday: '',
      patientGender: '',
      age: '',
      inDate: '',
      mRoomNm: '',
      medical_member_name: '',
      westMedicalNm: '',
      orientalDoctor: '',
    };
  },
  methods: {
    async printComponent(uid) {
      try {
        const { data } = await axiosClass.get(`/api/patient/view/${uid}`, {}, true);

        this.patientUid = data.memberData.PATIENT_UID;
        this.chartNo = data.memberData.CHART_NO;
        this.patientUsername = data.memberData.PATIENT_USERNAME;
        this.patientBirthday = data.memberData.PATIENT_BIRTHDAY;
        this.patientGender = data.memberData.PATIENT_GENDER;
        this.age = data.memberData.PATIENT_AGE;
        this.inDate = data.memberData.IN_DATE;
        this.medical_member_name = data.memberData.CONSULT_DOCTOR;
        this.westMedicalNm = data.memberData.WEST_MEDICAL_NM;
        this.mRoomNm = data.memberData.MEDICAL_ROOM_NUMBER_NM;
        this.orientalDoctor = data.memberData.MEDICAL_NM;
        this.printComponentData();
      } catch (err) {
        console.error(err);
      }
    },
    printComponentData() {
      var chartNo = this.chartNo;
      var pname = this.patientUsername;
      var pname2 = this.patientUsername;
      var sex = this.patientGender;
      var birthdate = this.patientBirthday;
      var age = this.age;
      var inDate = this.inDate;
      var mName = this.medical_member_name;
      var wName = this.westMedicalNm;
      var mRoomNm = this.mRoomNm;
      var oName = this.orientalDoctor;

      if (pname) {
        const lastChar = pname.slice(-1);
        if (isNaN(lastChar)) {
          pname = pname.slice(0, -1) + "*";
        } else {
          pname = pname.slice(0, -2) + "*" + lastChar;
        }
      } else {
        pname = "";
      }

      document.getElementById('chartNo2').innerText = chartNo;
      document.getElementById('sex').innerText = sex;
      document.getElementById('age').innerText = age;
      document.getElementById('pname2').innerText = pname2;
      document.getElementById('pname').innerText = pname;
      document.getElementById('birthdate').innerText = birthdate;
      document.getElementById('inDate').innerText = inDate;
      document.getElementById('roomNm').innerText = mRoomNm;

      if (!mName) {
        mName = "";
      }
      if (!wName) {
        wName = "";
      }

      document.getElementById('doctorWard').innerText = mName;
      document.getElementById('doctorWest').innerText = wName;
      document.getElementById('doctor2').innerText = mName + "\r\n" + wName;

      const el = this.$refs.pdfArea;

      // 230327 TH 추가 -> 배율에 상관없이 같은 크기로 캡쳐하여 인쇄하게 하는 세팅
      const canvasObj = document.createElement("canvas");
      canvasObj.width = 1920;
      canvasObj.height = 1280;

      const canvasOption = {
        canvasObj,
        scale: 0.89,
        width: 1920,
        height: 1280,
        windowHeight: 1280,
        windowWidth: 1920,
      };

      html2canvas(el, canvasOption).then(function (canvasObj) {
        const img = canvasObj.toDataURL();
        const tmp = window.open(" ");
        $(tmp.document.body)
          .html("<img src=" + img + " alt=''>")
          .ready(function () {
            tmp.focus();
            tmp.print();
            tmp.close();
          });
      });
    },

  },
};
</script>

<style>
.mx-datepicker-popup {
  z-index: 90000000 !important;
}

.activeMenu {
  border-color: #015666;
}

.activeMenu2 {
  border-bottom-width: 3px !important;
  border-color: #015666;
}

.tb_box {
  height: 630px;
  overflow: auto;
}

input::placeholder {
  color: rgb(185, 185, 185);
}

#memberPopup .vs-popup {
  width: 1200px !important;
}

#csPopup .vs-popup {
  width: 1200px !important;
}

.p-2 border border-solid text-center {
  padding: 0px;
  margin: 0px;
}

.colored {
  padding: 0px;
}
</style>
